module.exports = __webpack_public_path__ + "img/imgYLSYB(13).0df8e8d4.png";